import { CardContent } from "@material-ui/core";
import React, { Fragment } from "react";
import { Datagrid, FunctionField, TextField } from "react-admin";
import { DefaultPerPageSize } from "../../../../../Constants/Constant";
import { SourceEightWings } from "../../Constant/Source";
import { EightWingsStatus, EightWingsStatusArray } from "../../../../../Enums/EightWingsTabEnum";
import Actions from "./Actions";
import { GetServiceableStatus } from "../../../../../Enums/ServiceableStatus";
import { GetUnserviceableStatus } from "../../../../../Enums/UnserviceableStatus";
import { ExcelExport } from "../../../../../Helper/ExportExcel";
import { ExcelHeader } from "./Excel";
import PoolList from "../../../../../Components/PoolListComponent/PoolListComponent";
import { formatDate } from "../../../../../Helper/MomentHelper";

export const EightWingsTTVerifyList = props => {
  const ExportToExcel = (records, fetchRelatedRecords) => {
    ExcelExport(
      ExcelHeader,
      records.map(value => [
        value.request.refNo,
        value.request.customerPo,
        value.request.customerCode,
        value.request.requirementCategoryText,
        value.request.pn,
        value.request.isPool,
        value.request.airportCode,
        value.request.acRegistration,
        value.request.createdDate,
        value.request.requestedDeliveryDate === null
          ? "Not Arrived Yet"
          : value.request.requestedDeliveryDate == new Date("01/01/9999")
            ? "Exclude"
            : value.request.requestedDeliveryDate,
        GetServiceableStatus?.find?.(x => x.Value == value?.serviceable?.status)?.Description ?? "",
        GetUnserviceableStatus?.find?.(x => x.Value == value?.unserviceable?.status)?.Description ?? "",
        EightWingsStatusArray?.find?.(x => x.Value == value.status)?.Description ?? "",
        value.serviceable?.pn,
        value.serviceable?.sn,
      ]),
      "TT Verify List"
    );
  };
  return (
    <Fragment>
      <CardContent>
        <PoolList
          {...props}
          bulkActionButtons={false}
          title={"TT Verify List"}
          exporter={ExportToExcel}
          perPage={DefaultPerPageSize}
          resource={SourceEightWings}
          filter={{ status__in: [EightWingsStatus.WaitingTTVerify, EightWingsStatus.ServiceableDelivered] }}
          basePath=""
        >
          <Datagrid>
            <Actions label="Actions" props={props} />
            <TextField source="request.refNo" label={"Ref No"} />
            <TextField source="request.customerPo" label={"Customer PO"} />
            <TextField source="request.customerCode" label={"Customer"} />
            <TextField source="request.requirementCategoryText" label={"Requirement Category"} />
            <TextField source="request.pn" label={"Part No"} />
            <TextField source="request.isPool" label={"Pool Scope"} />
            <TextField source="request.airportCode" label={"Destination"} />
            <TextField source="request.acRegistration" label={"AC"} />
            <FunctionField
              label="Requested Date"
              render={(record: any) => {
                return formatDate(record.request.createdDate);
              }}
            />
            <FunctionField
              label="Requested Delivery Date"
              render={(record: any) => {
                return record.request.requestedDeliveryDate === null
                  ? "Not Arrived Yet"
                  : formatDate(record.request.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                    ? "Exclude"
                    : formatDate(record.request.requestedDeliveryDate, false);
              }}
            />
            <FunctionField
              label="Serviceable"
              render={(record: any) =>
                GetServiceableStatus?.find?.(x => x.Value == record?.serviceable?.status)?.Description ?? ""
              }
            />
            <FunctionField
              label="Core Unit"
              render={(record: any) =>
                GetUnserviceableStatus?.find?.(x => x.Value == record?.unserviceable?.status)?.Description ?? ""
              }
            />
            <FunctionField
              label="Status"
              render={(record: any) => EightWingsStatusArray?.find?.(x => x.Value == record.status)?.Description ?? ""}
            />
            <TextField source="serviceable.pn" label={"Svc Pn"} />
            <TextField source="serviceable.sn" label={"Svc Sn"} />
          </Datagrid>
        </PoolList>
      </CardContent>
    </Fragment>
  );
};

export default EightWingsTTVerifyList;
